<template>
  <div v-if="active && showBack" class="mp-back" :class="{ 'mp-back-pill': !immersive }" @click="goBack">
    <span class="mp-back-arrow"></span>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {mpImmersive, mpCanGoBack} from '@/utils/mp'

export default {
  data () {
    return {
      active: mpImmersive
    }
  },
  computed: {
    immersive () {
      return this.$route.name === 'performs'
    },
    showBack () {
      // 详情页返回键浮在海报模糊底上；其他页仅在有站内历史时给浮标，避免死胡同
      return this.immersive || mpCanGoBack()
    }
  },
  methods: {
    goBack () {
      if (mpCanGoBack()) {
        this.$router.back()
      } else {
        // 分享冷启动无站内历史，返回键回 H5 首页
        wx.miniProgram.redirectTo({url: '/pages/m/m'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mp-nav.vue